import { Box } from "@mui/material";
import { forwardRef, Fragment, Ref, useState } from "react";
import ContentAdmin from "../../../../components/contentAdmin";
import PanelTitle from "../../../../components/missions/PanelTitle";
import Buttons from "../clockMorning/feature/Buttons";
import Activities from "./feature/Activities";
import Environment from "./feature/Environment";
import People from "./feature/People";

const ClockEvening = forwardRef((props: Record<string, any>, ref: Ref<HTMLDivElement>) =>
{
	const [ stepClockEvening, setStepClockEvening ] = useState<number>(1);
	const [ disabledButtons, setDisabledButtons ] = useState<[ boolean, boolean, boolean ]>([ true, true, true ]);

	function handleBlip(key: number)
	{
		setDisabledButtons((prevState) => (
			Object.assign([], prevState, { [ key ]: false })
		));
	}

	const Components = [
		<Buttons setStepClockMorning={setStepClockEvening} disabledButtons={disabledButtons} handleBlip={handleBlip} />,
		<Environment setStepClockMorning={setStepClockEvening} />,
		<Activities setStepClockMorning={setStepClockEvening} />,
		<People setStepClockMorning={setStepClockEvening} />
	];

	return (
		<Box ref={ref} {...props} sx={{ flexDirection: "column", display: "flex", justifyContent: "space-between", height: "81vh", width: "100%", maxWidth: { xl: "980px", xs: "784px" }, m: "10px auto 0px" }}>
			<Box sx={{ maxWidth: "100%", mt: "-5px" }}>
				<PanelTitle
					positionOcta
					imageVariation="closeEye"
					title={<ContentAdmin limit={111} keyContent="contentMissionFive" keyText="clock_evening_title" defaultValue="Let’s design your evening" position="right" />}
				/>
				{/* <TransitionGroup className="TransitionGroup">
					{Components.map((Component, index) =>
					{
						if (stepClockEvening === index + 1)
						{
							return (
								<Grow key={index} timeout={{ enter: 1000, exit: 0 }} unmountOnExit>
									{Component}
								</Grow>
							);
						}
						return <Fragment key={index}></Fragment>;
					})}
					{stepClockEvening > Components.length && <Grow timeout={{ enter: 1000, exit: 0 }} unmountOnExit><h1>Step {stepClockEvening}</h1></Grow>}
				</TransitionGroup> */}
				{Components.map((Component, index) =>
				{
					if (stepClockEvening === index + 1)
					{
						return (
							<Box key={index}>{Component}</Box>
						);
					}

					return <Fragment key={index} />;
				})}
			</Box>
		</Box>
	);
});

export default ClockEvening;
